import "babel-polyfill";
import React, {Suspense} from 'react'
import {render} from 'react-dom'
import store from './store'
import {Provider} from 'react-redux'
import {FlashMessage} from "./components/FlashMessage";
import './i18n'
import component from './residentialMarketRoute'

// Global CSS styles
import 'toastr/build/toastr.css'

if (document.querySelector('#residentialMarket__container')) {
  render(
    (<Provider store={store}>
      <Suspense fallback="Wird geladen...">
        <FlashMessage/>
        {component}
      </Suspense>
    </Provider>),
    document.querySelector('#residentialMarket__container')
  )
}
